module.exports = __webpack_public_path__ + "img/logo1.e4225077.png";